<template>
  <v-container fluid>
    <v-toolbar dense dark tile flat class="title">
      Ministry Details and Objectives
    </v-toolbar>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="event.audience"
          label="Who is the Target Audience?"
          outlined
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="event.ministry"
          label="What Ministry is Running this Event?"
          outlined
          color="secondary"
          clearable
          :items="getMinistries"
        >
        </v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="event.setupPerson"
          label="Who Will Be Responsible for Setup?*"
          outlined
          color="secondary"
          :rules="rules.required"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="event.teardown"
          label="Who Will Be Responsible for Tear Down?*"
          outlined
          color="secondary"
          :rules="rules.required"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea 
          v-model="event.objectives" 
          label="What are your goals/objectives for this event?*" 
          color="secondary" 
          outlined
          :rules="rules.required"
        >
        </v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea 
          v-model="event.extraInfo" 
          label="Other pertinent info:"
          hint="Other costs or pertinent info." 
          color="secondary" 
          outlined
        >
        </v-textarea>
      </v-col>
      <v-col sm="12" md="6">
        <div class="">
          Will the event be recurring?
        </div>
        <v-radio-group v-model="event.recurring" column>
          <v-radio label="No" value="No" color="accent"></v-radio>
          <v-radio label="Weekly" value="Weekly" color="accent"></v-radio>
          <v-radio label="Monthly" value="Monthly" color="accent"></v-radio>
          <v-radio label="Custom" value="Custom" color="accent"></v-radio>
        </v-radio-group>
        <v-text-field
          v-if="event.recurring == 'Custom'"
          v-model="event.custom"
          label="How often will this event occur?"
          outlined
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col sm="12" md="6">
        <div>
          Is this a budgeted event?
        </div>
        <v-radio-group v-model="event.budgeted" column>
          <v-radio label="Yes" :value="true" color="accent"></v-radio>
          <v-radio label="No" :value="false" color="accent"></v-radio>
        </v-radio-group>
      </v-col>
      <!-- <v-col cols="12" md="6">
        <div class="">
          Do you have pre-made graphics for event promotion?
        </div>
        <v-radio-group v-model="event.graphic" column>
          <v-radio label="No" value="No"></v-radio>
          <v-radio label="Yes" value="Yes"></v-radio>
        </v-radio-group>
        <v-btn outlined small v-if="event.graphic == 'Yes'" disabled>
          <v-icon left small>fas fa-upload</v-icon>
          Upload File
        </v-btn>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import mixins from '@/plugins/mixins.js'
export default {
  mixins: [mixins],
  props: {
    eventInfo : Object
  },
  data(){
    return {
      event : this.eventInfo,
      menu  : false,
    }
  },
  computed: {
    getMinistries(){
      return this.$store.getters.getMinistries.sort()
    }
  }
}
</script>
